@if (itemsWithJsonData.length) {
    <app-table
        [items]="itemsWithJsonData"
        [columns]="columns"
        translatePrefix="form.iadl."
        [hideCheckboxes]="true"
        [resource]="resource"
        (detailCallback)="detail($event)"
        (deleteCallbackWithEvent)="delete($event)"
    >
        <ng-template pTemplate="printHeader"></ng-template>
        <ng-template pTemplate="print" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-print"
                (clickEvent)="print(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copyHeader"></ng-template>
        <ng-template pTemplate="copy" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-copy"
                (clickEvent)="copy(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="phoning" let-item="item">
            <span
                [pTooltip]="('form.iadl.phoningOptions.' + tooltipNames[item.data.phoning / 5]) | translate"
            >{{ ('form.iadl.dependencyOptions.' + dependencyNames[item.data.phoning / 5]) | translate }}</span>
        </ng-template>

        <ng-template pTemplate="transport" let-item="item">
            <span
                [pTooltip]="('form.iadl.transportOptions.' + tooltipNames[item.data.transport / 5]) | translate"
            >{{ ('form.iadl.dependencyOptions.' + dependencyNames[item.data.transport / 5]) | translate }}</span>
        </ng-template>

        <ng-template pTemplate="shopping" let-item="item">
            <span
                [pTooltip]="('form.iadl.shoppingOptions.' + tooltipNames[item.data.shopping / 5]) | translate"
            >{{ ('form.iadl.dependencyOptions.' + dependencyNames[item.data.shopping / 5]) | translate }}</span>
        </ng-template>

        <ng-template pTemplate="cooking" let-item="item">
            <span
                [pTooltip]="('form.iadl.cookingOptions.' + tooltipNames[item.data.cooking / 5]) | translate"
            >{{ ('form.iadl.dependencyOptions.' + dependencyNames[item.data.cooking / 5]) | translate }}</span>
        </ng-template>

        <ng-template pTemplate="housework" let-item="item">
            <span
                [pTooltip]="('form.iadl.houseworkOptions.' + tooltipNames[item.data.housework / 5]) | translate"
            >{{ ('form.iadl.dependencyOptions.' + dependencyNames[item.data.housework / 5]) | translate }}</span>
        </ng-template>

        <ng-template pTemplate="workAroundTheHouse" let-item="item">
            <span
                [pTooltip]="('form.iadl.workAroundTheHouseOptions.' + tooltipNames[item.data.workAroundTheHouse / 5]) | translate"
            >{{ ('form.iadl.dependencyOptions.' + dependencyNames[item.data.workAroundTheHouse / 5]) | translate }}</span>
        </ng-template>

        <ng-template pTemplate="medication" let-item="item">
            <span
                [pTooltip]="('form.iadl.medicationOptions.' + tooltipNames[item.data.medication / 5]) | translate"
            >{{ ('form.iadl.dependencyOptions.' + dependencyNames[item.data.medication / 5]) | translate }}</span>
        </ng-template>

        <ng-template pTemplate="finance" let-item="item">
            <span
                [pTooltip]="('form.iadl.financeOptions.' + tooltipNames[item.data.finance / 5]) | translate"
            >{{ ('form.iadl.dependencyOptions.' + dependencyNames[item.data.finance / 5]) | translate }}</span>
        </ng-template>

    </app-table>
}
